"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.FourMediaItem = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
  justifyContent: 'center',
  gap: theme.spacing(6),
  [theme.breakpoints.up('md')]: {
    width: 830,
    margin: 'auto'
  }
}));
const FourMediaItem = exports.FourMediaItem = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: '100%',
  maxWidth: 'unset',
  [theme.breakpoints.up('md')]: {
    maxWidth: _constants.IMAGE_DESKTOP_WIDTH
  }
}));
